export default __webpack_public_path__ + "9b9f931403f8d26a6cb3eaaa36cb64c6.png";